import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import deleteIcon from '../../../../../media/stakeholders/ic-delete.svg'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'

import ShareModal from '../../../widgets/components/ShareModal'
import { useThemeMode } from '../../../../../_metronic/partials'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../../../auth'
import { toast } from 'react-toastify'
import { deleteLinkedRecord, getLinkedRecords, getViewAndDownloadFile } from '../../core/_requests'
import { LinkedRecordsModal } from './LinkedRecordsModal'
import { NoDataPage } from '../../../resources/components/NoDataPage'
import SkeletonRow from '../../../digital-signing/components/SkeletonRow'
import { RecordSync, storageIcons } from '../../core/_constants'
import { getFileType } from '../../../../core/_util'
import ViewDocModal from '../../../stakeholders/stakeholders-and-investors/components/individual/view-doc-modal'
import { RecordKeeperCreateLinkDrawer } from './RecordKeeperCreateLinkDrawer'
import { DeleteClassificationModal } from '../RecordsClassifications/DeleteClassificationModal'
import { Pagination } from 'react-bootstrap'
import { RecordShareDrawer } from '../RecordShareDrawer'

const LinkedRecords = () => {
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  const { recordId } = useParams()
  const { mode } = useThemeMode()
  const [isCreateLinkActive, setIsCreateLinkActive] = useState(false)
  const [isShareActive, setIsShareActive] = useState(false)
  const [search, setSearch] = useState('')
  // const [filter, setFilter] = useState(false) //eslint-disable-line
  const [loading, setLoading] = useState(false)
  const [linkedRecords, setLinkRecords] = useState<any[]>([])
  const [showLinkedRecordsModal, setShowLinkedRecordsModal] = useState(false)
  const navigate = useNavigate()
  const [isActive, setIsActive] = useState(false)
  const [isFileLoading, setIsFileLoading] = useState(false)
  const [viewableData, setViewableData] = useState<
    { downloadUrl: string; fileName: string; extension: string } | {}
  >({})
  const [linkedRecordId, setLinkedRecordId] = useState<string | null>(null)
  const [openDeleteConfirmationModal, setOpenDeleteConfirmationModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [fileLinkedId, setFileLinkedId] = useState<string | null>(null)
  const [linkedRecordFileName, setLinkedRecordFileName] = useState<string>('')
  const [selectedLinkedRecordsIds, setSelectedLinkedRecordsIds] = useState<string[]>([])
  const [isOpenShareDrawer, setIsOpenShareDrawer] = useState(false)
  const [pagination, setPagination] = useState<{
    currentPage: number
    pageSize: number
    totalCount: number
    nextPage: number
    prevPage: number | null
    totalPages: number
  }>({
    currentPage: 1,
    pageSize: 10,
    totalCount: 0,
    nextPage: 0,
    prevPage: null,
    totalPages: 0,
  })

  // const handleFilter = () => {
  //   setFilter(true)
  // }

  const getAllLinkedRecords = async (recordId: string) => {
    if (!companyId || !recordId) return
    setLoading(true)
    try {
      const {
        data: { data, success, errors },
      } = await getLinkedRecords(companyId, recordId, pagination.currentPage, pagination.pageSize)
      if (success) {
        setPagination((prev) => ({
          ...prev,
          currentPage: data.pagination.currentPage,
          pageSize: data.pagination.pageSize,
          totalCount: data.pagination.totalRecords,
          nextPage: data.pagination.nextPage,
          prevPage: data.pagination.prevPage,
          totalPages: data.pagination.totalPages,
        }))
        setLinkRecords(data.data)
        setSelectedLinkedRecordsIds(data.data.map((record: any) => record.recordLinkedId))
      } else {
        toast.error(errors.name)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  const handlePageChange = (pageNumber: number) => {
    setPagination((prev) => ({ ...prev, currentPage: pageNumber }))
  }

  const handleDeleteLinkedFile = async () => {
    if (!companyId) return
    if (!fileLinkedId) return
    if (!recordId) return
    setDeleteLoading(true)
    try {
      const { data } = await deleteLinkedRecord(fileLinkedId, companyId)
      if (data.success) {
        toast.success('Linked record deleted successfully')
        setOpenDeleteConfirmationModal(false)
        getAllLinkedRecords(recordId)
      } else {
        toast.error('Failed to delete linked record')
      }
    } catch (error) {
      toast.error('Failed to delete linked record')
    } finally {
      setDeleteLoading(false)
    }
  }

  useEffect(() => {
    if (recordId) getAllLinkedRecords(recordId)
  }, [pagination.currentPage, pagination.pageSize]) // eslint-disable-line react-hooks/exhaustive-deps

  console.log('linkedRecords', linkedRecords)

  // Filter records based on search input
  const filteredRecords = linkedRecords?.filter((record: any) =>
    record.linkedFiles.documentName.toLowerCase().includes(search.toLowerCase())
  )

  const handleViewAndDownloadFile = async (
    { fileName, fileVersionId }: { fileName: string; fileVersionId: string },
    isDownload: boolean
  ) => {
    if (!companyId) return
    if (!isDownload) setIsActive(true)
    setIsFileLoading(true)
    try {
      const {
        data: { data, success },
      } = await getViewAndDownloadFile(fileVersionId, companyId)
      if (success) {
        if (isDownload) {
          const link = document.createElement('a')
          link.href = data.downloadUrl
          link.setAttribute('download', fileName || 'downloaded-file') // Ensure a valid filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          toast.success(`${fileName} downloaded successfully`)
        } else {
          setViewableData(data)
        }
      }
    } catch (error) {
      toast.error('Failed to download document')
    } finally {
      setIsFileLoading(false)
    }
  }

  return (
    <div>
      <div style={mode === 'dark' ? { background: '#151521' } : {}}>
        <div className='d-flex justify-content-end pb-4'>
          {/* <div className='h-100 border bg-white d-flex align-items-center rounded'>
            <button
              className='text-clr88 btn btn-sm btn-flex fw-semibold font-size-13 py-4 py-md-3'
              title='Sort and Filter'
              type='button'
              onClick={handleFilter}
            >
              <img src={FilterIconFunnel} alt='' />
              <span className='d-none d-md-block ms-2'>{formatMessage({id: 'Filter'})}</span>
            </button>
          </div> */}
          <div className='d-flex flex-md-row flex-column align-items-center gap-2 w-md-auto w-100'>
            <form className=' align-items-center w-100 w-md-auto d-flex'>
              <span className='svg-icon svg-icon-3 position-absolute ms-3'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  className='mh-50px'
                >
                  <rect
                    opacity='0.5'
                    x='17.0365'
                    y='15.1223'
                    width='8.15546'
                    height='2'
                    rx='1'
                    transform='rotate(45 17.0365 15.1223)'
                    fill='currentColor'
                  ></rect>
                  <path
                    d='M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z'
                    fill='currentColor'
                  ></path>
                </svg>
              </span>
              <input
                type='text'
                className='bg-body form-control form-control-flush ps-10 height-36px rounded font-weight-400 text-clrA1'
                name='search'
                placeholder='Search'
                data-kt-search-element='input'
                onChange={(e) => setSearch(e.target.value)}
              />
            </form>
            <button
              className='btn bg-primary custom-button-property text-white justify-content-center font-weight-400 font-size-13 height-36 d-flex align-items-center w-md-auto w-100'
              onClick={() => setShowLinkedRecordsModal(true)}
            >
              {formatMessage({ id: 'Add Linked Records' })}
            </button>
            {recordId && (
              <LinkedRecordsModal
                showLinkedRecordsModal={showLinkedRecordsModal}
                setShowLinkedRecordsModal={setShowLinkedRecordsModal}
                recordId={recordId}
                getAllLinkedRecords={getAllLinkedRecords}
                selectedLinkedRecordsIds={selectedLinkedRecordsIds}
              />
            )}
          </div>
        </div>
      </div>
      <ShareModal isActive={isShareActive} setIsActive={setIsShareActive} />
      <div className='bg-white rounded p-4'>
        <h1 className='font-size-16'>{formatMessage({ id: 'Linked Files' })}</h1>

        {loading ? (
          <table className='w-100'>
            <SkeletonRow count={4} />
          </table>
        ) : (
          <>
            {linkedRecords.length === 0 ? (
              <NoDataPage />
            ) : (
              <>
                {filteredRecords?.map((record: any) => (
                  <div
                    key={record.id}
                    className='d-flex align-items-center justify-content-between my-2 py-2'
                    style={
                      mode === 'dark'
                        ? { borderBottom: '1px dotted #565674' }
                        : { borderBottom: '1px dotted #DBDFE9' }
                    }
                  >
                    <div className='d-flex align-items-center'>
                      <img
                        src={getFileType(record.linkedFiles.recordKeeperFileVersion.fileName)}
                        alt='pdf'
                        height={32}
                        width={32}
                        className='me-3'
                      />
                      <div className='d-flex flex-column'>
                        <p className='font-size-13 m-0'>
                          {formatMessage({ id: record.linkedFiles.documentName })}
                        </p>
                        <p className='font-size-10 m-0'>
                          <span className='me-2'>
                            <img
                              src={toAbsoluteUrl(
                                `/media/icons/RecordsKeeperAI/${storageIcons[
                                record.linkedFiles.recordKeeperFileVersion.recordKeeperSource
                                  .cloudType as RecordSync
                                ]
                                }.svg`
                              )}
                              alt='drive'
                              height={16}
                              width={16}
                            />
                          </span>
                          {record?.structureClassificationLevelOne.name}/
                          {record?.structureClassificationLevelTwo.name}/                       
                          {record?.structureClassificationLevelThree.name}
                        </p>
                      </div>
                    </div>
                    <div className='d-flex gap-2'>
                      <div
                        className='p-3 cursor-pointer bg-light rounded-2 d-flex justify-content-center align-items-top height-36'
                        onClick={() =>
                          navigate(
                            `/rk/records-and-files/${encodeURIComponent(
                              record?.structureClassificationLevelOne.name
                            )}/${encodeURIComponent(
                              record?.structureClassificationLevelTwo.name
                            )}/${encodeURIComponent(record?.structureClassificationLevelThree.name)}`
                          )
                        }

                      >
                        <i className='fa-solid fa-arrow-up-right-from-square font-size-16'></i>
                      </div>
                      <div
                        role='button'
                        className='p-3 cursor-pointer bg-light rounded-2 d-flex justify-content-center align-items-top height-36'
                        onClick={() => {
                          setLinkedRecordFileName(record.linkedFiles.documentName)
                          handleViewAndDownloadFile(
                            {
                              fileName: record.linkedFiles.recordKeeperFileVersion.fileName,
                              fileVersionId:
                                record.linkedFiles.recordKeeperFileVersion.fileVersionId,
                            },
                            false
                          )
                        }}
                      >
                        <img
                          src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-view.svg')}
                          alt='view'
                          width={20}
                          height={20}
                        />
                      </div>
                      <div
                        role='button'
                        className='p-3 cursor-pointer bg-light rounded-2 d-flex justify-content-center align-items-top height-36'
                        onClick={() =>
                          handleViewAndDownloadFile(
                            {
                              fileName: record.linkedFiles.recordKeeperFileVersion.fileName,
                              fileVersionId:
                                record.linkedFiles.recordKeeperFileVersion.fileVersionId,
                            },
                            true
                          )
                        }
                      >
                        <img
                          src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-download.svg')}
                          alt='download'
                          width={20}
                          height={20}
                        />
                      </div>
                      <button
                        className='btn btn-light justify-content-center text-primary border border-primary font-weight-400 font-size-13 height-36 d-flex align-items-center w-md-auto w-100'
                        style={
                          mode === 'dark' ? { background: 'transparent' } : { background: '#F0F4FF' }
                        }
                        onClick={() => {
                          setLinkedRecordId(record.recordLinkedId)
                          setIsCreateLinkActive(true)
                        }}
                      >
                        {formatMessage({ id: 'Create Link' })}
                      </button>
                      <div
                        role='button'
                        className='p-3 cursor-pointer bg-light rounded-2 d-flex justify-content-center align-items-top height-36'
                        onClick={() => {
                          setFileLinkedId(record.fileLinkedId)
                          setOpenDeleteConfirmationModal(true)
                        }}
                      >
                        <img src={deleteIcon} alt='delete' width={20} height={20} />
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}

            {!loading && linkedRecords?.length > 0 && pagination.totalCount > 10 && (
              <div className='w-100 d-md-flex justify-content-between align-items-center px-0 mt-8'>
                <div className='d-flex gap-2 w-100 align-items-center justify-content-md-start justify-content-center mb-4'>
                  <select
                    aria-label='Default select example'
                    className={`p-4 py-3 w-80px border border-1 rounded-2 font-size-13 bg-white text-dark ${mode === 'dark' ? ' border-dark' : ''
                      }`}
                    value={pagination.pageSize}
                    onChange={(e) => {
                      const newSize = Number(e.target.value)
                      setPagination((prev) => ({
                        ...prev,
                        pageSize: newSize,
                        pageIndex: 0, // Reset to first page when page size changes
                      }))
                    }}
                  >
                    {[10, 20, 50, 100].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>

                  <span className='font-size-13 text-center text-md-start'>
                    {formatMessage({
                      id: `Showing ${pagination.currentPage === 1
                        ? 1
                        : (pagination.currentPage - 1) * pagination.pageSize + 1
                        } to ${pagination.nextPage ? linkedRecords.length : pagination.totalCount
                        } of ${pagination.totalCount} records`,
                    })}
                  </span>
                </div>

                <Pagination className='w-md-100 w-auto d-flex flex-md-end justify-content-center justify-content-md-end '>
                  <Pagination.First
                    onClick={() => handlePageChange(1)}
                    disabled={!pagination.prevPage}
                  >
                    {'<<'}
                  </Pagination.First>

                  <Pagination.Prev
                    onClick={() => handlePageChange(pagination.currentPage - 1)}
                    disabled={!pagination.prevPage}
                  >
                    {'<'}
                  </Pagination.Prev>

                  {Array.from({ length: pagination.totalPages }, (_, i) => (
                    <Pagination.Item
                      key={i}
                      active={i === pagination.currentPage - 1}
                      onClick={() => handlePageChange(i + 1)}
                    >
                      {i + 1}
                    </Pagination.Item>
                  ))}

                  <Pagination.Next
                    onClick={() => handlePageChange(pagination.currentPage + 1)}
                    disabled={!pagination.nextPage}
                  >
                    {'>'}
                  </Pagination.Next>

                  <Pagination.Last
                    onClick={() => handlePageChange(pagination.totalPages)}
                    disabled={!pagination.nextPage}
                  >
                    {'>>'}
                  </Pagination.Last>
                </Pagination>
              </div>
            )}
            <ViewDocModal
              isActive={isActive}
              setIsActive={setIsActive}
              fileName={linkedRecordFileName}
              isRecordKeeper={true}
              isLoading={isFileLoading}
              viewableData={viewableData}
            />
            {linkedRecordId && (
              <>
                <RecordKeeperCreateLinkDrawer
                  recordId={linkedRecordId}
                  createLinkDrawer={isOpenShareDrawer}
                  setCreateLinkDrawer={setIsOpenShareDrawer}
                  setCreateRecordDrawer={setIsCreateLinkActive}
                />
                <RecordShareDrawer
                  recordId={linkedRecordId}
                  createRecordDrawer={isCreateLinkActive}
                  setCreateRecordDrawer={setIsCreateLinkActive}
                  setIsOpenShareDrawer={setIsOpenShareDrawer}
                />
              </>
            )}
            <DeleteClassificationModal
              setDeleteShowModal={setOpenDeleteConfirmationModal}
              showDeleteModal={openDeleteConfirmationModal}
              handleDelete={handleDeleteLinkedFile}
              deleteLoading={deleteLoading}
              headingMessage={'Delete Linked Record'}
              description={`Are you sure you want to delete this linked record?`}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default LinkedRecords
